import { Card, CardContent, CardHeader } from "@mui/material";
import React, { FC, ReactNode } from "react";

interface SectionCardProps {
    title: ReactNode;
    children: ReactNode;
}

const SectionCard: FC<SectionCardProps> = ({ title, children }) => (
    <Card
        sx={{
            mb: 3,
            width: "100%",
            minHeight: "2em",
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            backgroundColor: "#fcfcfc",
            boxShadow: "none",
            // Change from flex to block layout
            display: "block",
        }}
    >
        <CardHeader
            sx={{
                pl: 2,
                py: 1,
                fontSize: "1.4em",
                width: "100%",
                boxSizing: "border-box", // ⬅ important
                backgroundColor: "#f1f1f675",
                borderBottom: "1px solid #e0e0e0",
                textAlign: "left",
            }}
            title={title}
        />
        <CardContent sx={{
            py: 0,
            width: "100%",
            boxSizing: "border-box", // ⬅ important
            "&:last-child": {
                pb: 1,
            },
        }}>
            {children}
        </CardContent>
    </Card>
);

export default React.memo(SectionCard);